import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyA9ii3yPyQaGs2XrUmgZCr1zQ2ILsOMLUs",
  authDomain: "space-messengers.firebaseapp.com",
  projectId: "space-messengers",
  storageBucket: "space-messengers.appspot.com",
  messagingSenderId: "97371880616",
  appId: "1:97371880616:web:53b5214e4cfbd0cd5f969d"

};





firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth;
export const db = firebase.firestore();

export const storageRef = firebase.storage().ref();